import React from 'react';
import { CustomSettingsItemType } from '../Enums/CustomSettingsItemType.enum';
import CustomSettingsTableItem from './CustomSettingsTable/CustomSettingsTableItem';
import styles from './CustomSettingsItem.module.scss';
import YesNoRadioField from '../../Base/Components/YesNoRadioField/YesNoRadioField';

export interface CustomSettingsItemScheme {
	key: string;
	label: string;
	type: CustomSettingsItemType;
}

interface Props {
	item: CustomSettingsItemScheme;
}

const FIELDS: Record<
	CustomSettingsItemType,
	(name: string) => React.ReactNode
> = {
	[CustomSettingsItemType.YES_NO_FIELD]: (name: string) => (
		<YesNoRadioField name={name} inLine />
	),
};

const CustomSettingsItem: React.FC<Props> = ({ item }) => {
	return (
		<CustomSettingsTableItem label={item.label} className={styles.wrapper}>
			{FIELDS[item.type](item.key)}
		</CustomSettingsTableItem>
	);
};

export default CustomSettingsItem;
